/* global window, $ */
(function () {
  if (!window.JIYUCHO_SCHEDULE) return;

  var S = window.JIYUCHO_SCHEDULE;

  var STORE_KEY = String(window.RESERVE_STORE || "JIYUCHO").trim().toUpperCase();
  if (STORE_KEY !== "FUTO") STORE_KEY = "JIYUCHO";

  var rangeName = STORE_KEY === "FUTO" ? "v2_fulldatelist-futo" : "v2_fulldatelist";

  var spreadsheetId = "11Zbhg767ACJk6oEgdrCu8jWNjVKht-N1XwnqlHYE_C8";
  var apiKey = "AIzaSyCf6elGCWq9rjx_CLaQlTtn3HmRfvLXyIc";

  var SHEET_URL =
    "https://sheets.googleapis.com/v4/spreadsheets/" +
    spreadsheetId +
    "/values/" +
    encodeURIComponent(rangeName) +
    "?key=" +
    apiKey;

  var dts = [];
  var ready = false;

  var $form = $("#ReservationForm");
  var $btn = $("#reserve_submit");

  var $np = $("#ReservationForm-numperson");
  if (!$np.length) $np = $("[name='numperson'], [name='people'], #numperson, #people");

  var $sch1 = $("#ReservationForm-schedule1");
  var $sch2 = $("#ReservationForm-schedule2");
  var $skipSch2 = $("#ReservationForm-skip-schedule2");

  var timer = null;

  function isEnglishPage_() {
    var lang = document.documentElement && document.documentElement.getAttribute("lang");
    if (lang && String(lang).toLowerCase().indexOf("en") === 0) return true;

    if (window.Shopify && typeof window.Shopify.locale === "string") {
      if (window.Shopify.locale.toLowerCase().indexOf("en") === 0) return true;
    }

    return window.location.pathname.indexOf("/en/") === 0;
  }

  function getSubmitTexts_() {
    return isEnglishPage_()
      ? {
          available: "Submit Reservation",
          unavailable: "Unavailable"
        }
      : {
          available: "予約申し込み",
          unavailable: "予約不可"
        };
  }

  function getNumPersons_() {
    var v = ($np && $np.length) ? $np.val() : null;
    if ((v == null || String(v).trim() === "") && window.currentReservation) {
      v = window.currentReservation.numperson ||
        window.currentReservation.people ||
        window.currentReservation.peopleCount;
    }
    var n = parseInt(v, 10);
    return isFinite(n) && n > 0 ? n : 1;
  }

  function isPublicSameDay_(value) {
    var policy = window.JIYUCHO_RESERVATION_SAME_DAY;
    return !!(
      value &&
      policy &&
      typeof policy.isSameDayValue === "function" &&
      policy.isSameDayValue(value, STORE_KEY)
    );
  }

  function clearSameDaySelection_($schedule) {
    if (!$schedule || !$schedule.length) return;
    var input = $schedule[0];
    input.value = "";
    input.setAttribute("value", "");
    try { input.dispatchEvent(new Event("input", {bubbles: true})); } catch (e1) {}
    try { input.dispatchEvent(new Event("change", {bubbles: true})); } catch (e2) {}
  }


  function selectedMenuText_() {
    var el = document.getElementById("ReservationForm-menu");
    if (!el) return "";
    var opt = el.options[el.selectedIndex];
    if (!opt) return "";
    return [opt.id || "", opt.value || "", opt.text || ""].join(" ");
  }

  function passLatestStartRule_(val) {
    if (!val) return true;
    var rules = window.JIYUCHO_RESERVABLE_TIME_RULES;
    if (!rules || typeof rules.isDateTimeReservable !== "function") return true;
    var dt = S.parseAsJSTLocalInput ? S.parseAsJSTLocalInput(val) : new Date(val);
    return rules.isDateTimeReservable({ store: STORE_KEY, dateTime: dt, menu: selectedMenuText_() });
  }

  function getMenuLimitOffsetMinutes_() {
    var menu = selectedMenuText_();
    var rules = window.JIYUCHO_RESERVABLE_TIME_RULES;

    if (rules && typeof rules.getMenuLimitOffsetMinutes === "function") {
      var fromRules = parseInt(rules.getMenuLimitOffsetMinutes(menu), 10);
      if (isFinite(fromRules) && fromRules > 0) return fromRules;
    }

    if (rules && typeof rules.isLetterReservationMenu === "function") {
      return rules.isLetterReservationMenu(menu) ? 90 : 30;
    }

    return /t-price|①|一年後の自分へ手紙を書く|手紙|letter|future/i.test(menu) ? 90 : 30;
  }

  function getEls(suffix) {
    return {
      reject: $("#display_rejectreservation_text" + suffix),
      notBusiness: $("#display_notbusinesshour_text" + suffix),
      noSeat: $("#display_noseat_text" + suffix),
      notEnough: $("#display_noenoughseat_text" + suffix),
      priceBox: $("#display_price_box" + (suffix === "1" ? "" : "2"))
    };
  }

  function resetUI(els) {
    els.reject.hide();
    els.notBusiness.hide();
    els.noSeat.hide();
    els.notEnough.hide();
    els.priceBox.hide();
  }

  function disableBooking(els, key) {
    resetUI(els);
    els[key].show();
  }

  function checkBusiness(val, suffix) {
    if (!val) return true;

    var els = getEls(suffix);
    resetUI(els);

    var date = S.parseAsJSTLocalInput(val);
    var r = typeof S.validateReservationDateTime === "function"
      ? S.validateReservationDateTime(date, STORE_KEY, selectedMenuText_())
      : S.isBusinessDateTime(date, STORE_KEY);
    if (!r.ok) {
      disableBooking(els, r.key === "latestStart" ? "notBusiness" : r.key);
      return false;
    }
    return true;
  }

  function parseSheetDateLooseJST_(v) {
    if (v instanceof Date) return v;

    var s = String(v || "").trim();

    // yyyy/M/d HH:mm:ss も yyyy/MM/dd HH:mm:ss も通す
    var m = s.match(/^(\d{4})\/(\d{1,2})\/(\d{1,2})\s+(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?$/);
    if (!m) return null;

    var y = parseInt(m[1], 10);
    var mo = parseInt(m[2], 10);
    var d = parseInt(m[3], 10);
    var h = parseInt(m[4], 10);
    var mi = parseInt(m[5], 10);
    var se = parseInt(m[6] || "0", 10);

    var dt = typeof S.jstDate === "function"
      ? S.jstDate(y, mo, d, h, mi, se)
      : S.parseAsJSTLocalInput(y + "-" + String(mo).padStart(2, "0") + "-" + String(d).padStart(2, "0") + "T" + String(h).padStart(2, "0") + ":" + String(mi).padStart(2, "0") + ":" + String(se).padStart(2, "0"));
    if (!(dt instanceof Date) || isNaN(dt)) return null;
    return dt;
  }

  function hasHeaderRow_(values) {
    if (!values || !values.length) return false;
    var r0 = values[0] || [];
    var a = parseSheetDateLooseJST_(r0[0]);
    var b = parseSheetDateLooseJST_(r0[1]);
    return !(a && b);
  }


  function checkSeat(val, suffix) {
    if (!val) return true;

    var els = getEls(suffix);

    if (!ready) {
      disableBooking(els, "noSeat");
      return false;
    }

    var selected = S.parseAsJSTLocalInput(val);
    var now = new Date();

    if (S.isSameJstDay(now, selected)) {
      disableBooking(els, "reject");
      return false;
    }

    if (S.isTooLateTomorrowJST(now, selected)) {
      disableBooking(els, "reject");
      return false;
    }

    var numPersons = getNumPersons_();

    var startIndex = hasHeaderRow_(dts) ? 1 : 0;

    var matched = false;
    var errorKey = null;
    var selectedEnd = new Date(selected.getTime() + getMenuLimitOffsetMinutes_() * 60 * 1000);

    for (var i = startIndex; i < dts.length; i++) {
      var row = dts[i] || [];

      var from = parseSheetDateLooseJST_(row[0]);
      var to = parseSheetDateLooseJST_(row[1]);

      var availSlots = parseInt(row[2], 10);
      if (!isFinite(availSlots)) availSlots = 0;

      var availPeople = parseInt(row[3], 10);
      if (!isFinite(availPeople)) availPeople = availSlots;
      // console.log(from);

      if (!(from instanceof Date) || isNaN(from) || !(to instanceof Date) || isNaN(to)) continue;

      // sheet 側は end を 17:59:59 みたいに含む形なので <= にする
      var isWithinRow = from <= selected && selected <= to;
      var overlapsFullRow = availPeople <= 0 && selected <= to && selectedEnd > from;

      if (isWithinRow || overlapsFullRow) {
        matched = true;

        if (availPeople <= 0) errorKey = "noSeat";
        else if (numPersons > availPeople) errorKey = "notEnough";

        break;
      }
    }

    if (matched && errorKey) {
      disableBooking(els, errorKey);
      return false;
    }

    return true;
  }

  function refreshSuffix(suffix) {
    if (suffix === "2" && isSchedule2Skipped_()) {
      resetUI(getEls(suffix));
      return true;
    }

    var $sch = suffix === "1" ? $sch1 : $sch2;
    var val = $sch && $sch.length ? $sch.val() : "";

    var els = getEls(suffix);
    resetUI(els);

    if (isPublicSameDay_(val)) {
      clearSameDaySelection_($sch);
      disableBooking(els, "reject");
      return false;
    }

    if (!checkBusiness(val, suffix)) return false;
    if (!checkSeat(val, suffix)) return false;
    if (!passLatestStartRule_(val)) {
      disableBooking(els, "notBusiness");
      return false;
    }

    if (val) els.priceBox.show();
    return true;
  }

  function refreshAll() {
    var ok1 = refreshSuffix("1");
    var ok2 = refreshSuffix("2");

    var can = ok1 && ok2 && ready && isFormReadyForSubmit_();
    var txt = getSubmitTexts_();

    $btn
      .prop("disabled", !can)
      .val(can ? txt.available : txt.unavailable)
      .css("color", can ? "" : "#000");
    return can;
  }

  function isFormReadyForSubmit_() {
    syncSchedule2SkipState_();

    var form = $form && $form.length ? $form[0] : null;
    if (form && typeof form.checkValidity === "function" && !form.checkValidity()) return false;

    var confirmEmail = document.getElementById("confirm-email");
    var email = document.getElementById("ReservationForm-email");
    if (email && confirmEmail) {
      var emailValue = String(email.value || "").trim();
      var confirmValue = String(confirmEmail.value || "").trim();
      if (!emailValue || !confirmValue || emailValue !== confirmValue) return false;
    }

    if ($form && $form.find(".num-error").length > 0) return false;

    var attentionIds = [
      "reservation-attention-confirm",
      "reservation-attention-cancel-fee",
      "reservation-attention-summary"
    ];
    for (var i = 0; i < attentionIds.length; i++) {
      var el = document.getElementById(attentionIds[i]);
      if (el && !el.checked) return false;
    }

    return true;
  }

  function isSchedule2Skipped_() {
    return $skipSch2 && $skipSch2.length > 0 && $skipSch2.prop("checked");
  }

  function syncSchedule2SkipState_() {
    if (!$sch2 || !$sch2.length) return;
    var skipped = isSchedule2Skipped_();
    if (skipped && $sch2.val()) $sch2.val("");
    $sch2.prop("required", !skipped);
    $sch2.prop("disabled", skipped);
    $sch2.attr("aria-required", skipped ? "false" : "true");
    if (skipped && $sch2[0] && typeof $sch2[0].setCustomValidity === "function") {
      $sch2[0].setCustomValidity("");
    }
    if (skipped) resetUI(getEls("2"));
  }

  function scheduleRefresh() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(refreshAll, 50);
  }

  $.get(SHEET_URL)
    .done(function (data) {
      dts = data && data.values ? data.values : [];
      ready = true;
      refreshAll();
    })
    .fail(function () {
      dts = [];
      ready = false;
      refreshAll();
    });

  if ($np && $np.length) $np.on("input change blur", scheduleRefresh);
  if ($sch1 && $sch1.length) $sch1.on("input change blur", scheduleRefresh);
  if ($sch2 && $sch2.length) $sch2.on("input change blur", scheduleRefresh);
  if ($skipSch2 && $skipSch2.length) $skipSch2.on("change", function () {
    syncSchedule2SkipState_();
    scheduleRefresh();
  });

  // click 以外の submit も止める
  if ($form && $form.length) {
    $form.on("submit", function (e) {
      refreshAll();
      if ($btn.prop("disabled")) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    });
  }

  $btn.on("click", function (e) {
    refreshAll();
    if ($btn.prop("disabled")) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  });

  var txt = getSubmitTexts_();
  syncSchedule2SkipState_();
  $btn.prop("disabled", true).val(txt.unavailable).css("color", "#000");

  window.JIYUCHO_RESERVATION_VALIDATION = {
    validateAll: refreshAll,
    isReady: function () { return ready; },
    getStoreKey: function () { return STORE_KEY; }
  };
})();
